import { useDispatch, useSelector } from 'react-redux'
import { Pagination, SectionPanel, Spinner } from '@/components/ui'
import { useUrlFilters } from '@/hooks/useUrlFilters'

import { fetchBiens, setFilters, searchBiens } from '../../biens/biensSlice'
import BienItemLocataire from './BienItemLocataire'
import BienItemLocataireCard from './BienItemLocataireCard'
import BienSearch from '../proprietaire/BienSearch'

export default ({ids = []}) => {
  const dispatch = useDispatch()
  const biens = useSelector((state) => state.biens.items)
  const filters = useSelector((state) => state.biens.filters)
  const pagination = useSelector((state) => state.biens.pagination)
  const isLoading = useSelector((state) => state.biens.loadingStatus.fetchList)

  useUrlFilters({
    setFiltersAction: setFilters,
    fetchAction: (filters) => {
      if(filters.term) {
        return searchBiens(filters)
      } else {
        return fetchBiens(filters)
      }
    },
    filters,
    allowedParams: ['page', 'limit'],
  })

  const handlePageChange = (page) => {
    dispatch(setFilters({ page }))
  }

  return (
    <div className="overflow-x-hidden">
      <SectionPanel>
        <SectionPanel.Title className="font-normal flex flex-col md:flex-row">
          <div className="mb-4">
            <h2 className="text-md md:text-xl text-center font-semibold mb-2">
              Vos locations chez HPI
            </h2>
          </div>
          <div className="flex items-right justify-between items-center mb-4">
            <BienSearch />
          </div>
        </SectionPanel.Title>
        <SectionPanel.Body columns={1} bgColor={"white"} className='p-0'>
          {/* Affiche sur petits écrans */}
          <div className="block lg:hidden">
            {isLoading && <p><Spinner color='primary'/></p>}
            {!isLoading &&
              <div className="flex flex-wrap gap-4">
                { biens.length === 0 ?
                  <div className="text-center py-4 text-gray-600 italic">
                    Aucune location trouvée
                  </div> :
                  biens.map( (item, index) => <BienItemLocataireCard key={index} bien={item}/> )
                }
              </div>
            }
          </div>

          {/* Affichage sur écran > 768px en tableau  */}
          <div className="hidden lg:block w-full overflow-x-auto">
            <table className="table table-zebra">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Loyer</th>
                  <th>Charges</th>
                  <th>Adresse</th>
                  <th>Surface</th>
                </tr>
              </thead>
              <tbody>
                {isLoading && <tr><td colSpan="7"><Spinner color='primary'/></td></tr>}
                {!isLoading && biens.length === 0 && (
                  <tr>
                    <td colSpan="7" className="text-center py-4 text-gray-600 italic">
                      Aucune location trouvée
                    </td>
                  </tr>
                )}
                { !isLoading && biens.length > 0 && (biens.map(
                  (bien) => (
                    <BienItemLocataire key={bien.id} bien={bien} />
                  ))
                )}
              </tbody>
            </table>
          </div>
          {pagination.totalPages > 1 && (
            <Pagination
              currentPage={pagination.currentPage}
              totalPages={pagination.totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </SectionPanel.Body>
      </SectionPanel>
    </div>
  )
}